import { removeLeadingZeros } from '../../helpers/removeLeadingZeros';
import { MarkupType, TaxType } from 'application-types';

type ProductFieldValue = string | number | MarkupType | TaxType | undefined | null;

function sanitizeNumericField(value: ProductFieldValue): ProductFieldValue {
  const sanitized = typeof value === 'string' ? removeLeadingZeros(value) : value;

  return sanitized ?? value;
}

function sanitizeObjectField(value: MarkupType | TaxType): MarkupType | TaxType {
  const sanitizedValue = typeof value.value === 'string' ? removeLeadingZeros(value.value) : value.value;

  return {
    ...value,
    value: sanitizedValue ?? value.value,
  };
}

export function sanitizeProductValue(value: ProductFieldValue, field: string): ProductFieldValue {
  const numericFields = ['rate', 'netPrice', 'creditAmount'];
  
  if (numericFields.includes(field)) {
    return sanitizeNumericField(value);
  }
  
  if ((field === 'markup' || field === 'tax') && value && typeof value === 'object' && 'value' in value) {
    return sanitizeObjectField(value);
  }
  
  return value;
}

